import { render, staticRenderFns } from "./upDataImg.vue?vue&type=template&id=db001f02&scoped=true"
import script from "./upDataImg.vue?vue&type=script&lang=js"
export * from "./upDataImg.vue?vue&type=script&lang=js"
import style0 from "./upDataImg.vue?vue&type=style&index=0&id=db001f02&prod&scoped=true&lang=css"
import style1 from "./upDataImg.vue?vue&type=style&index=1&id=db001f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db001f02",
  null
  
)

export default component.exports